import { useSessionProvider } from "@/lib/providers/session/use-session";
import { WebSocketProvider as BaseWebSocketProvider } from "@/lib/websocket/context";

type WebSocketProviderProps = React.PropsWithChildren;

/**
 * WebSocket Provider that integrates with session authentication Only connects when user is
 * authenticated
 */
export function WebSocketProvider({ children }: WebSocketProviderProps) {
  const { session } = useSessionProvider();
  const isAuthenticated = session.data?.user?.id != null;

  // Don't render WebSocket provider if not authenticated
  if (!isAuthenticated) {
    return <>{children}</>;
  }

  // Get backend URL for WebSocket connection
  const backendUrl = import.meta.env.VITE_BACKEND_URL || "https://api.heyboomer.localhost";

  return (
    <BaseWebSocketProvider
      options={{
        url: backendUrl,
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
      }}
    >
      {children}
    </BaseWebSocketProvider>
  );
}
